__turbopack_context__.v({
  "centerTitle": "PrimaryPromoBoxes-module-scss-module__a8Ta7W__centerTitle",
  "container": "PrimaryPromoBoxes-module-scss-module__a8Ta7W__container",
  "sectionContainer": "PrimaryPromoBoxes-module-scss-module__a8Ta7W__sectionContainer",
  "titleContainer": "PrimaryPromoBoxes-module-scss-module__a8Ta7W__titleContainer",
});
